import React, { Component } from "react";
import { bulbIcon } from "../../../utils/images";
import InputForm from "../../html/inputForm";
import SelectForm from "../../html/selectForm";
import SelectDropDownForm from "./selectDropDownForm";
import commonContext, { AppContext } from "../../../context/common";
import { leadType } from "../../../../app";
import VehicleInfoHeader from "./vehicleInfoHeader";

interface IProps {
    contextState?: object;
    changeState?: Function;
}
interface IState {}
export class VehicleInfoForm extends Component<IProps, IState> {
    static contextType = commonContext;
    setLead: Function;
    apis: any;
    lead: leadType;
    async componentDidMount() {
        this.setLead = (this.context as AppContext).setLead;
        this.apis = (this.context as AppContext).apis;
        this.lead = (this.context as AppContext).lead as leadType;

        const apiData = await this.apis.getStates(this.lead);
        this.setLead({
            statesArray: apiData.result,
            state: this.lead?.pdPresentState,
        });
        this.handleOnStateChange(null);
    }
    handleOnChange = (e: any) => {
        let state = {};
        state[e.target.name] = e.target.value;
        this.setLead(state);
    };
    handleOnStateChange = async (e: any) => {
        this.lead = (this.context as AppContext).lead as leadType;
        const apiData = await this.apis.getCities(this.lead);
        this.setLead({
            citysList: apiData.result,
        });
    };
    handleOnCityChange = async (e: any) => {
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead({
            manufacturerList: [],
            makeList: [],
            modelList: [],
            dealersList: [],
        });
        const apiData = await this.apis.getManufacturers(this.lead);
        this.setLead({
            manufacturerList: apiData.result,
        });
    };
    handleOnManufacturerChange = async (e: any) => {
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead({
            manufacturer: e.target.value,
            makeList: [],
            modelList: [],
            dealersList: [],
        });
        this.lead.manufacturer = e.target.value;
        const apiData = await this.apis.getMakes(this.lead);
        this.setLead({
            makeList: apiData.result,
        });
    };
    handleOnMakeChange = async (e: any) => {
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead({
            modelList: [],
            dealersList: [],
        });
        const apiData = await this.apis.getModels(this.lead);
        this.setLead({
            modelList: apiData.result,
        });
    };
    handleOnModelChange = async (e: any, modelList: any) => {
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead({
            dealersList: [],
        });
        modelList.forEach((model: any) => {
            if (model.modelId == e.target.value) {
                this.setLead({ modelDescription: model.model });
            }
        });
        const apiData = await this.apis.getModelInfoNDealers(this.lead);
        this.setLead({
            ...apiData.result,
            avgCostModal: parseFloat(apiData.result.avgCost),
            rtoEditAmount: apiData.result.rto,
            roadTax: apiData.result.rto,
            motorInsurancePremium: apiData.result.motorInsurancePremAmt,
            VDOnRoadCost:
                parseFloat(apiData.result.avgCost) +
                parseFloat(apiData.result.rto) +
                parseFloat(apiData.result.motorInsurancePremAmt),
        });
    };

    render() {
        const { lead } = this.context;
        return (
            <>
                <VehicleInfoHeader />
                <div className="flex flex-wrap w-full">
                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                        <InputForm
                            readonly={true}
                            label="State"
                            errorText=""
                            value={lead?.pdPresentState}
                            handlerOnChange={() => {}}
                        />
                    </div>
                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                        <SelectForm
                            title="City"
                            noneText="Select City"
                            errorText="Please select city"
                            options={lead.citysList}
                            name="city"
                            handlerOnChange={async (e) => {
                                await this.handleOnChange(e);
                                await this.handleOnCityChange(e);
                            }}
                            value={lead.city}
                        />
                    </div>
                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                        <SelectForm
                            title="Manufacturer"
                            noneText="Select Manufacturer"
                            errorText="Please select manufacturer"
                            options={lead.manufacturerList}
                            name="mfg"
                            handlerOnChange={async (e) => {
                                await this.handleOnChange(e);
                                await this.handleOnManufacturerChange(e);
                            }}
                            value={lead.mfg}
                        />
                    </div>
                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                        <SelectForm
                            title="Car Make"
                            noneText="Select Car Make"
                            errorText="Please select car make"
                            options={lead.makeList}
                            name="make"
                            handlerOnChange={async (e) => {
                                await this.handleOnChange(e);
                                await this.handleOnMakeChange(e);
                            }}
                            value={lead.make}
                        />
                    </div>
                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                        <SelectForm
                            title="Car Model"
                            noneText="Select Car Model"
                            errorText="Please select car model"
                            options={lead.modelList}
                            name="modelId"
                            objectKey="model"
                            handlerOnChange={async (e) => {
                                await this.handleOnChange(e);
                                await this.handleOnModelChange(
                                    e,
                                    lead.modelList
                                );
                            }}
                            value={lead.modelId}
                        />
                    </div>
                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                        <SelectDropDownForm
                            title="Dealer"
                            errorText="Please select Dealer"
                            name="dealerSupplierId"
                            handlerOnChange={(e) => this.handleOnChange(e)}
                            value={lead.dealerSupplierId}
                        />
                    </div>
                    <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                        <InputForm
                            label="Ex-showroom price quoted by the dealer"
                            errorText="Please enter ex-showroom price quoted by the dealer"
                            prefix="Rs."
                            name="avgCost"
                            handlerOnChange={(e) => {
                                this.handleOnChange({
                                    target: {
                                        name: e.target.name,
                                        value: parseInt(e.target.value),
                                    },
                                });
                            }}
                            value={lead.avgCost}
                        />
                    </div>
                    <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                        <InputForm
                            label="Discount offered by the dealer"
                            errorText="Please enter discount offered by the
                    dealer"
                            prefix="Rs."
                            name="discountPrice"
                            handlerOnChange={(e) => {
                                this.handleOnChange(e);
                            }}
                            value={lead.discountPrice}
                        />
                    </div>
                </div>
            </>
        );
    }
}

export default VehicleInfoForm;
